import { Info } from 'lucide-react'
import { cn } from '@/lib/utils'
import { useMessages } from '@/i18n'
import { messages } from './messages'

/** Плашка «что такое базовый язык» во вкладке «Язык» настроек; в меню шапки тот же
 *  текст — подсказкой у бейджа «Базовый». */
export const BaseLangHint = ({ className }: { className?: string }) => {
  const m = useMessages(messages)
  return (
    <div className={cn('flex items-center gap-4 rounded-2xl bg-foreground/5 p-5', className)}>
      <span className="flex size-9 shrink-0 items-center justify-center rounded-full bg-brand/15 text-brand">
        <Info className="size-5" />
      </span>
      <p className="text-[15px] leading-relaxed text-muted-foreground">{m.baseLangHint}</p>
    </div>
  )
}
